import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import { detectLangFromPath, DEFAULT_LANG, HTML_LANG, SupportedLang } from './utils/lang';

const resources = {
  en: { translation: en },
  zh: { translation: zh },
  ja: { translation: ja },
};

/**
 * Pick the initial language from the URL path prefix only.
 * English lives at site root (/), Chinese at /zh/*, Japanese at /ja/*.
 * Users switch language via the language selector (full navigation + localStorage).
 */
function pickInitialLanguage(): SupportedLang {
  if (typeof window !== 'undefined') {
    return detectLangFromPath(window.location.pathname);
  }
  return DEFAULT_LANG;
}

const initialLang = pickInitialLanguage();

if (typeof document !== 'undefined') {
  document.documentElement.lang = HTML_LANG[initialLang];
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANG,
    lng: initialLang,
    debug: import.meta.env.DEV,
    interpolation: { escapeValue: false },
  });

export default i18n;
